export default {
      id: "tooltip_empty-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#tooltip_empty",
      toString: function () {
        return this.url;
      }
    }